// Copyright (c) 2016 Deere & Company

import KeyValueCollection, {getDefaultState} from '@deere/cps-it.warranty-model-factory/lib/key-value-pair-collection';
import actions from '../../action-list';

const setOwnershipStatus = (state, action) =>
    KeyValueCollection.update(state, {
        $set: action.statusCollection
    });

export default (state = getDefaultState(), action) => {

    const actionTypes = {
        [actions.UPDATE_OWNERSHIP_STATUS_COLLECTION]: setOwnershipStatus
    };

    const reducer = actionTypes[action.type];

    return reducer ?
        reducer(state, action) :
        state;

};



// WEBPACK FOOTER //
// ./src/claim/shared/reducers/ownership-status.js